import { observer } from 'mobx-react-lite'
import { CardFormFields } from 'pages/settings/ui/BillingPlan'
import { type CheckoutCardStore } from 'pages/clients/pages/create/store/checkoutCardStore'

type ICheckoutCardFormProps = {
  store: CheckoutCardStore
}

export const CheckoutCardForm = observer(({ store }: ICheckoutCardFormProps) => {
  const {
    nameError,
    cardError,
    apiError,
    name,
    setName,
    onChangeCard,
    setOnSubmit,
    clearCardError,
  } = store

  return (
    <CardFormFields
      name={name}
      setName={setName}
      nameError={nameError}
      cardError={cardError}
      apiError={apiError}
      onChangeCard={onChangeCard}
      setOnSubmit={setOnSubmit}
      clearCardError={clearCardError}
      withFocus={false}
    />
  )
})
